import { render, staticRenderFns } from "./AcademicRecordDisplay.vue?vue&type=template&id=10f5e722&scoped=true&"
import script from "./AcademicRecordDisplay.vue?vue&type=script&lang=js&"
export * from "./AcademicRecordDisplay.vue?vue&type=script&lang=js&"
import style0 from "./AcademicRecordDisplay.vue?vue&type=style&index=0&id=10f5e722&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f5e722",
  null
  
)

export default component.exports